import { GROUP } from '~/consts';

export const state = () => ({
  viewed_materials: {}
});

export const mutations = {
  pushViwedMaterial(state, { id, post_id }) {
    let viewed_materials = {...state.viewed_materials};
    viewed_materials[id] = collect(viewed_materials[id]).push(post_id).unique().toArray();
    state.viewed_materials = viewed_materials;
  },
  setViewedMaterials(state, { id, post_ids }) {
    let viewed_materials = {...state.viewed_materials};
    viewed_materials[id] = collect(post_ids).unique().toArray()
    state.viewed_materials = viewed_materials;
  },
  setState(state, { key, value }) {
    state[key] = value
  }
}

export const actions = {
  getViewedMaterials({ commit }, {id, data}) {
    this.$axios.post(GROUP.GET_VIEWED_MATERIALS(id), { gmid: data.gmid })
      .then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          commit("setViewedMaterials", {id, post_ids: data.data.postIds});
        } else {
        }
      });
  }
}
